import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/shop-development")({
  beforeLoad: () => {
    throw redirect({
      to: "/en/services/ecommerce-development",
      statusCode: 301,
    });
  },
  server: {
    handlers: {
      GET: async () => {
        return new Response(null, {
          status: 301,
          headers: { Location: "/en/services/ecommerce-development" },
        });
      },
    },
  },
});
